import { curry, eq, get, isEmpty, mergeAll, pipe } from 'lodash/fp';
import { omitByWithKey } from './lodash-ext';
/**
 * It does a shallow comparison between a new object and the old one,
 * and picks only those new key-value pairs that have changed.
 *
 * @param {object} newObject - first object to compare
 * @param {object} oldObject - second object to compare
 * @example
 * const newObject = { name: 'John', age: 25 }
 * const oldObject = { name: 'John', age: 30 }
 *
 * pickDifferent(newObject)(oldObject)
 * // { age: 25 }
 *
 * pickDifferent(oldObject)(oldObject)
 * // null
 *
 * // Avoid re-rendering a component
 * this.setState(oldState => pickDifferent(newState)(oldState))
 *
 * // ...or even shorter
 * this.setState(pickDifferent(newState))
 */

export var pickDifferent = curry(function (newObject, oldObject) {
  return pipe([mergeAll, omitByWithKey(function (value, key) {
    return eq(value, get(key, oldObject));
  }), function (result) {
    return isEmpty(result) ? null : result;
  }])([oldObject, newObject]);
});
export default pickDifferent;